import ForumRoundedIcon from "@mui/icons-material/ForumRounded";

export const forum = (props) => {
  return <ForumRoundedIcon {...props} />;
};
